import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import ContactSection from '@/pages/home/components/ContactSection';
import IndexSection from '@/pages/home/components/IndexSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AppSection from '@/pages/home/components/AppSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <IndexSection />
        <FaqSection />
        <AppSection />
        <AboutSection />
        <CarouselSection />
        <RankingSection />
        <CardsSection />
        <UpdatesSection />
        <CommentsSection />
        <MediaSection />
        <TopicsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}